export default () => ({
  idInput: {
    width: '100%',
    marginBottom: '30px',
  },
  labelText: {
    color: '#3D3F43',
  },
  inputText: {
    color: '#3D3F43',
  },
});
